import useOnClickOutside from './closeBurger';

export default useOnClickOutside;
